import { Link as RemixLink } from "@remix-run/react";
import { Box, Button, Heading, Text, VStack } from "@chakra-ui/react";
import { ArrowForwardIcon } from "@chakra-ui/icons";

import { getOfferCopy } from "#app/config/freeAccessOffers.js";
import { OfferPill } from "./OfferPill.jsx";
import { ReviewProof } from "./ReviewProof.jsx";

/**
 * Single-facility hero for featured + partner pages — the search-free sibling
 * of HomeHero. The page already targets one facility, so the primary action is
 * "check available dates": a jump to the on-page AvailabilityCalendar
 * (#calendar) rather than a search box. Sponsored partners surface their
 * free-access offer as a pill above the headline.
 */
export function FacilityHero({
  name,
  subtitle,
  reviews = [],
  stats,
  freeAccessOffer,
}) {
  const offer = getOfferCopy(freeAccessOffer);

  return (
    <VStack
      spacing={0}
      textAlign="center"
      px={{ base: 4, md: 6 }}
      pt={{ base: 4, md: 10 }}
      maxW="container.md"
      mx="auto"
      w="100%"
    >
      {offer && (
        <OfferPill
          label={offer.pill}
          mb={4}
          data-testid="facility-hero-free-access-pill"
        />
      )}

      <Heading
        as="h1"
        fontSize={{ base: "4xl", md: "5xl" }}
        lineHeight="1.05"
        letterSpacing="tight"
        fontWeight="extrabold"
      >
        {name} fully&nbsp;booked?{" "}
        <Text as="span" color="warning">
          Schnerp&nbsp;it!
        </Text>
      </Heading>

      {subtitle && (
        <Text
          mt={4}
          fontSize={{ base: "lg", md: "xl" }}
          maxW="xl"
          color="muted"
        >
          {subtitle}
        </Text>
      )}

      <Button
        mt={8}
        as={RemixLink}
        to="#calendar"
        variant="primary"
        size="lg"
        fontWeight="bold"
        rightIcon={<ArrowForwardIcon />}
      >
        Check available dates
      </Button>

      <Box mt={6}>
        <ReviewProof reviews={reviews} stats={stats} />
      </Box>
    </VStack>
  );
}
